import script from "./user_image.vue?vue&type=script&setup=true&lang=js"
export * from "./user_image.vue?vue&type=script&setup=true&lang=js"

import "./user_image.vue?vue&type=style&index=0&id=1eed77cb&lang=scss&scoped=true"

import exportComponent from "/root/buildarea/v8-development-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1eed77cb"]])

export default __exports__